<sn-data-list #listElement reloadByQueryParams [fetchFn]="loadData">
  <sn-infinite-scroll windowScrollTarget>
    <sn-pull-to-refresh>
      <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="table"></ng-template>
      <ng-template
        [ngIf]="!list.dataSource.data.length && list.dataIsInited"
        [ngIfThen]="emptyList"
      ></ng-template>
    </sn-pull-to-refresh>
  </sn-infinite-scroll>

  <ng-template #table>
    <fs-alpr-search-exports-table
      data-testid="export-table"
      [columns]="columns"
      [items]="list?.dataSource?.data"
      [actions]="actions"
      [sort]="sort"
      [sortDirection]="sortDirection"
      (sortChange)="onSortChange($event)"
    >
    </fs-alpr-search-exports-table>
  </ng-template>

  <ng-template #emptyList>
    <sn-empty-state  data-testid="empty-state" icon="cancel_presentation" title="{{ 'common.noResults' | t }}">
      {{ 'common.noResultsMatchSearch' | t }}
    </sn-empty-state>
  </ng-template>
</sn-data-list>
